// extracted by mini-css-extract-plugin
export var label = "_bs-1";
export var reminder = "_bs-0";